import React from 'react';
import { Chip as ChipNew } from './Chip';
import { convertOldChipProps } from './converter.old';
import type { OldChipProps } from './converter.old';

export type ChipProps = OldChipProps;

export const Chip = React.forwardRef<HTMLButtonElement, ChipProps>((props, ref) => (
  <ChipNew {...convertOldChipProps(props)} ref={ref} />
));
